import React from 'react';
import ReactDOM from 'react-dom/client';
import AuthProvider from './components/AuthProvider';
import Unlock from './Unlock';
import { StyledEngineProvider } from '@mui/material/styles';
const root = document.getElementById('unlock-root');
// const root = document.querySelector('.form-container');
if (root) {
  ReactDOM.createRoot(root).render(
    <StyledEngineProvider injectFirst>
      <React.StrictMode>
        <AuthProvider>
          <Unlock />
        </AuthProvider>
      </React.StrictMode> 
    </StyledEngineProvider>

  );
}